import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Table } from 'components/UI'
import TeacherTable from './TeacherTable'
import LessonTable from './LessonTable'
import StudentTable from './StudentTable'
import lessonTableSettings from "./LessonTable/table-settings"
import studentTableSettings from "./StudentTable/table-settings"
import teacherTableSettings from "./TeacherTable/table-settings"
import {fetchClassStudent} from './StudentTable/ducks'
import {fetchClassTeacher} from './TeacherTable/ducks'
import {fetchClassLesson} from './ducks'
import locale from './locale'

const mapStateToProps = (state) => ({
  user: state.user,
  gSubscription: state.gSubscription,
  classStudentDetail: state.classStudentDetail,
  classTeacherDetail: state.classTeacherDetail,
  schoolDetail: state.schoolDetail,
})

class DefaultTab extends Component{
  constructor(props){
    super(props)
  }

  componentWillMount(){
    let {dispatch, title, onTabChange} = this.props
    const classId = this.props.params.classId

    if(title == 'student'){
      dispatch(fetchClassStudent(Number(classId)))
    } else if (title == 'teacher'){
      dispatch(fetchClassTeacher(Number(classId)))
    } else if (title === 'pastLesson'){
      onTabChange('past');
    }else if (title === 'currentLesson'){
      onTabChange('current');
    }
  }

  render(){
    const {title, dispatch, classDetail, pagination, onPageChange, onItemsCountPerPageChange} = this.props
    const {fetching} = classDetail
    if(title == 'currentLesson'){
      const {classDetail} = this.props
      const {detail} = classDetail
      this.lessonTableSettings = lessonTableSettings.call(this);
      this.lessonsState = 'current';

      return(
        <LessonTable 
          state={this.lessonsState} 
          tableData={detail} 
          settings={this.lessonTableSettings} 
          dispatch={dispatch} 
          fetching={fetching} 
          pagination={pagination}
          usePagination={true}
          onPageChange={onPageChange}
          onItemsCountPerPageChange={onItemsCountPerPageChange}
          {...this.props} 
        />
      )
    } else if (title === 'pastLesson'){
      const {classDetail} = this.props
      const {detail} = classDetail
      this.lessonTableSettings = lessonTableSettings.call(this);
      this.lessonsState = 'past';

      return(
        <LessonTable 
          state={this.lessonsState} 
          tableData={detail} 
          settings={this.lessonTableSettings} 
          dispatch={dispatch} 
          fetching={fetching} 
          pagination={pagination}
          usePagination={true}
          onPageChange={onPageChange}
          onItemsCountPerPageChange={onItemsCountPerPageChange}
          {...this.props}
        />
      )
    }else if(title == 'student'){
      const {classStudentDetail} = this.props
      const {detail} = classStudentDetail
      this.studentTableSettings = studentTableSettings.call(this);

      let arr = []
      if(detail.classStudentList){
        detail.classStudentList.map((student) => {
          if(student.classStudentState == 1){
            arr.push(student)
          }
        })
      }

      let newdetail = {...detail, classStudentList: arr}
      return(
        <StudentTable tableData={newdetail} classDetail={classDetail} settings={this.studentTableSettings} {...this.props} />
      )
    } else if (title == 'pastStudent'){
      const {classStudentDetail} = this.props
      const {detail} = classStudentDetail
      this.studentTableSettings = studentTableSettings.call(this);

      let arr = []
      if(detail.classStudentList){
        detail.classStudentList.map((student) => {
          if(student.classStudentState == 0){
            arr.push(student)
          }
        })
      }

      let newdetail = {...detail, classStudentList: arr}

      return(
        <StudentTable tableData={newdetail} classDetail={classDetail} settings={this.studentTableSettings} {...this.props} />
      )
    } else if (title == 'teacher'){
      const {classTeacherDetail} = this.props
      const {detail} = classTeacherDetail
      this.teacherTableSettings = teacherTableSettings.call(this);
      return(
        <TeacherTable
          tableData={detail}
          classDetail={classDetail}
          settings={this.teacherTableSettings}
          {...this.props}
        />
      )
    }
  }
}


export default connect(mapStateToProps)(DefaultTab)



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/DefaultTab.js